import axios from "axios";
import Vue from "vue";
import Result from "../../utils/serviceResultPattern";

export default {
  duplicateProduct(supplierId, product) {
    return axios
      .post("/api/inventory/duplicateProduct", { supplierId, product })
      .then((res) => {
        Vue.toasted.success('Product duplicated successfully');
        return Result.ok(res.data);
      })
      .catch((error) => {
        const message = error.response && error.response.data && error.response.data.message;
        return Result.error(message);
      });
  },

  getProductById(supplierId, productId) {
    return axios
      .get("/api/inventory/GetProductById", { params: { supplierId, productId } })
      .then((res) => {
        if (!res.data) {
          return Result.error("We couldn't load the product at this time. Please try again or contact support if the issue persists.");
        }
        return Result.ok(res.data);
      })
      .catch((error) => {
        return Result.error(error);
      });
  },

  editProduct(supplierId, product) {
    return axios
      .post("/api/inventory/EditProduct", { supplierId, product })
      .then((res) => Result.ok(res.data))
      .catch(() => {
        return Result.error("We couldn't update the product at this time. Please try again or contact support if the issue persists.");
      });
  },   
};



// WEBPACK FOOTER //
// ./src/api/product/productService.js